export var pcaKey = 'RU29-JW76-FF25-GH29';

export var postCodeSeparator = '~~~~';

export var updateFinanceOptions = {
    prefix: '£'
};
